// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** Mastercard */
export const Mastercard = createBankIcon({
  name: "Mastercard",
  slug: "mastercard",
  compe: null,
  color: "#ffffff",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#ffffff;fill-opacity:1\"\n     id=\"mastercard_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(21.0155,32.0935) scale(0.05800)\">\n    <path d=\"m308,0a309,309 0 1,0 2,0z\" style=\"fill:#EB001B\" />\n    <path d=\"m690,0a309,309 0 1,0 2,0z\" style=\"fill:#F79E1B\" />\n    <path d=\"m500,66a309,309 0 0,0 0,486 309,309 0 0,0 0-486\" style=\"fill:#FF5F00\" />\n  </g>",
});
